import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const DeleteHolidayModal = ({ show, onHide, onDelete, holidayName }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header>
        <Modal.Title>Delete Holiday</Modal.Title>
        <button onClick={onHide} className="modal-close">
          <i className="bi bi-x-lg fs-5"></i>
        </button>
      </Modal.Header>
      
      <Modal.Body>
        <p>Are you sure you want to delete <strong>{holidayName}</strong> from the calendar?</p>
        <p className="text-danger mb-0"><small>This action cannot be undone.</small></p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="cancel-cta" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onDelete}>
          Yes, Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteHolidayModal;